import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useParams} from 'react-router-dom';
import {getInvoice, getInvoiceByAccessCode} from 'redux/actions';
import './invoice.css';
import Loading from 'components/shared-components/Loading';
import PrintedInvoice from './PrintedInvoice';

const PrintInvoiceAccessCode = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const { invoice } = useSelector((s) => s.invoices);

  useEffect(() => {
    // If access code is provided execute alternate function to get invoice
    if (params.access_code) {
      dispatch(getInvoiceByAccessCode(params.invoice_id, params.access_code));
    } else {
      dispatch(getInvoice(params.invoice_id));
    }
  }, [dispatch, params]);

  if (!invoice) {
    return <Loading />;
  }

  return (
    <PrintedInvoice
      id={params.invoice_id}
      accessCode={params.access_code}
      invoice={invoice}
      account={invoice?.account}
      customer={invoice?.customer}
    />
  );
};

export default PrintInvoiceAccessCode;
